export default __webpack_public_path__ + "static/media/3.16c62fed.png";